import { Component, inject } from '@angular/core';
import { AppFacadeService } from '../../../services/app-facade.service';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Invoice } from '../../../models/invoice-model';

@Component({
    standalone: false,
    selector: 'por-invoice-selection-checkbox-renderer',
    templateUrl: './invoice-selection-checkbox-renderer.html'
})
export class InvoiceSelectionCheckboxRendererComponent implements ICellRendererAngularComp {
    readonly appFacadeService = inject(AppFacadeService);

    public params!: ICellRendererParams;
    public invoice!: Invoice;

    agInit(params: ICellRendererParams): void {
        this.params = params;
        this.invoice = { ...params.data };
    }

    onCheckboxChange(isChecked: boolean): void {
        if (this.params.context && this.params.context.componentParent) {
            this.params.context.componentParent.onSelectionChanged(isChecked, this.invoice.Id);
        }
    }

    refresh(): boolean {
        return false;
    }
}
